// tab_nav 菜单按钮列表
const tab_list = [
  {
      value: "1",
      label: '基地维修',
      component_name: 'TabContentOne'
  },
  {
      value: "2",
      label: '在线维保',
      component_name: 'TabContentTwo'
  },
  {
      value: "3",
      label: '备件供应',
      component_name: 'TabContentThree'
  },
  {
      value: "4",
      label: '升级改造',
      component_name: 'TabContentFour'
  },
  {
      value: "5",
      label: '诊断测试',
      component_name: 'TabContentFive'
  },
  {
      value: "6",
      label: '技术培训',
      component_name: 'TabContentSix'
  }
]

// main content 头部文本
const main_content_text = [
  `六十载深耕工业控流领域，无锡凯尔克以 “全品牌兼容运维专家” 之姿，构建覆盖全国的敏捷服务网络，配备工业级高精度检测平台及移动智修方舱，提供现场快修、返厂深度维护双轨服务。`,
  `从超低温深冷阀到核级主蒸汽调节阀，从石油炼化到清洁能源工程，以原厂级工艺标准突破技术壁垒，护航全球500强企业设备零宕机运行。以匠心致恒远，以智造链通未来，KELK以硬核技术矩阵与全天候响应体系，赋能产业脉动永续不息。`
]

// main content 列表
const main_content_list = [
  {
      value: 1,
      title: '基地维修',
      content: [
          `KELK可针对所有类型的阀门提供专业服务 ‒ 不受结构型式、尺寸和制造商的限制。我们提供各种与控制阀维修有关的服务，主要包括：`,
          `提供用户现场紧急支援服务，包括紧急故障处理、紧急备件提供等特殊服务；提供用户现场的装置停车控制阀集中维修服务，包括在线维护和...
          `
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw01.jpg',
      bg_img_class: 'main-content__list-item__img-bg1'
  },
  {
      value: 2,
      title: '在线维保',
      content: [
          'KELK提供专业的阀门维保服务。可预防故障，保证设备的可靠运行和高度可用性。',
          '所有服务量身定制，确保良好的开端，也适用于其他制造商的产品。'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw02.jpg',
      bg_img_class: 'main-content__list-item__img-bg2'
  },
  {
      value: 3,
      title: '备件测绘',
      content: [
          'KELK服务部门拥有种类丰富的库存材料，能确保在保养和检修阀门时迅速提供大部分零件。同时与部分阀门制造商备件库保持动态数据联动，可以为用户提供快速的备件服务。'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw03.jpg',
      bg_img_class: 'main-content__list-item__img-bg3'
  },
  {
      value: 4,
      title: '升级改造',
      content: [
          '近年来，我们的升级和改装服务帮助世界各地的客户，使他们的设备在苛刻使用条件下也能保持良好的性能。典型项目包括通过升级阀内件来避免砂粒杂质，通过更换成硬质合金及LCV阀内件来减少气蚀影响等等。'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw04.jpg',
      bg_img_class: 'main-content__list-item__img-bg4'
  },
  {
      value: 5,
      title: '诊断测试',
      content: [
          'KELK拥有自己的实验室，我们有现场分析的专家，我们可对材料进行所有非破坏性检验和机械检验，主要包括 X 射线、超声波和显微结构检查等。所有检查结果通过证书进行证明，同时我们能进行复杂的材料、冶金和电子元件的测试...'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw05.jpg',
      bg_img_class: 'main-content__list-item__img-bg5'
  },
  {
      value: 6,
      title: '技术培训',
      content: [
          '我们的课程是循序渐进的，我们也可以和您一起评估您员工的培训要求，并推荐合适的课程确保达到预期的学习效果。我们已从客户那里获得了非常积极的培训反馈，适当的培训有助于客户理解在他们工作范围内的阀门...'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw06.jpg',
      bg_img_class: 'main-content__list-item__img-bg6'
  }
]


// 基地维修
const baseMmaintenance = {
  title: '全品牌全场景覆盖',
  content: `
  无锡凯尔克提供全品类阀门检修服务，兼容全球品牌，无惧结构差异、尺寸限制与工艺壁垒。<br />
  国家级流体控制实验室与三维激光测绘技术，从超低温深冷阀到核级高压调节阀，我们提供定制化拆解检测、核心部件修复、智能升级改造一站式服务，严格遵循API/ISO认证标准，让每一台阀门重焕工业级精度与可靠性。
  `,
  group1: {
    title: '我们提供的维修服务主要包括',
    list: [
      '提供用户现场紧急支援服务，包括紧急故障处理、紧急备件提供等特殊服务；',
      '提供用户现场的装置停车控制阀集中维修服务，包括在线维护和下线检修；',
      '提供发运至各维修基地或工厂的阀门维修服务；'
    ]
  },
  rights_list: [
    {
      value: 1,
      title: '您将获益',
      content: '您的装置可以安排控制阀维修的点对点的联系人，同样也适用于第三方产品'
    },
    {
      value: 2,
      title: '您将获益',
      content: '多年积累的维修经验和深厚的制造商专业技术知识，确保再生阀门的安全和可靠性'
    },
    {
      value: 3,
      title: '您将获益',
      content: '所有控制阀（包括第三方控制阀）维修后无论外观还是性能均可保证完美如初'
    },
    {
      value: 4,
      title: '您将获益',
      content: '所有阀门都拥有历史记录文档以保证透明度，可随时扫码在线查看'
    }
  ]
}

// 在线维保
const onlineMaintenance = {
  title: '预见性守护工业脉动',
  content: `
  无锡凯尔克在线维保服务以预测性维护为核心，通过智能诊断系统实时监测阀门健康状态，精准预防故障隐患。<br />
  基于工业物联网（IIoT）平台与全生命周期健康数据库，提供全品牌兼容的定制化维保方案——从密封组件智能预警到执行机构远程校准，适配超低温、核电等严苛场景，让非KELK品牌阀门亦享原厂级运维标准，同步实现能效优化与成本节降。
  `,
  group1: {
    title: '我们提供的维修服务主要包括',
    list: [
      '提供用户全厂或部分装置的控制阀365*24的保运服务',
      '提供用户全厂或部分装置的控制阀定期巡检或点检服务',
      '提供控制阀现场安装调试、指导开车服务'
    ]
  },
  group2: {
    title: '如果您需要有关阀门大修和维修的帮助和建议，请联系我们。',
    content: '文字暂代文字暂代我们的客户包括行业领先的公司，例如 Agip、Aramco、BP、ConocoPhillips、ExxonMobil、Fina、Petronas、Petrobras',
    button_text: '联系我们'
  },
  rights_list_title: '您将获益',
  rights_list: [
    '一站式阀门维保服务，24小时随叫随到',
    '经验丰富的KELK专家以及具有专业技术的制造商确保设备安全可靠',
    '顺利启动您的设备，为您的设备保驾护航，从一开始就实现最大生产率',
    '及时进行必要的维修，在磨损之前更换零件，提高运行可靠性，避免停机',
    '专业的维保规划和设备的运行，遵守维护期限，使得控制阀的成本最优化'
  ]
}

// 备件测绘
const sparePartsMapping = {
  title: '精准复刻与敏捷响应双擎驱动',
  content: `
  无锡凯尔克依托三维激光测绘与智能逆向工程系统，覆盖 150# 至 2500# 阀门核心组件，实现95%常用配件24小时极速交付。<br />
  通过工业互联网平台与全球Top10阀门制造商备件数据链协同，提供非标件动态建模、特种合金定制熔铸及密封组件仿生优化服务，同步执行ISO 9001/API 6D标准质检，赋能老旧设备焕新升级与全生命周期管理。
  `,
  group1: [
    {
      title: '客户零库存',
      content: `通过就近服务中心为客户提供“零库存”的备件服务，仓库管理系统可提供最佳的备件储备建议，由此防止库存过剩或者备件短缺。降低仓储成本，改善供货情况`,
    },
    {
      title: '逆向工程',
      content: `测绘出图加工各种特殊阀门或非标的阀内件;短时间内可以提供品牌阀门及其他阀门有关的各种阀门备品备件;`,
    }
  ],
  flowImg: require('@/assets/images1/customer_service/khfw18.png'),
  rights_list_title: '您将获益',
  rights_list: [
    '替代不再供货的原厂零件',
    '在订购相关的小零件时避免出错，不会遗漏任何东西',
    '与单独订货相比有价格优势，甚至不需要占用资率',
    '所有零件都具有一如既往的KELK质量保证',
    '交货时间短，提升效率，可以实现新的运行点'
  ]
}

// 升级改造
const upgradingAndReconstruction = {
  title: '重塑工业设备生命力',
  content: `
  无锡凯尔克以全球领先阀门再生技术，赋能高温高压、强腐蚀等工况下的设备性能跃升，延长使用寿命300%显著提升能效。<br />
  通过多级降压迷宫阀芯、硬密封等离子涂层、LCV防气蚀合金组件等定制化改造方案，适配超临界火电、LNG深冷储运等场景，同步植入智能传感器与流体动力学仿真优化系统，满足API 6D严苛认证标准，让传统阀门焕发智能工业时代新价值。
  `,
  group1: {
    title: '我们如何帮助客户',
    subTitle: 'KELK始终专注于通过改造和维护的办法在整个阀门生命周期中优化设备的使用性能，',
    help_txt_list: [
      '提供装置改造过程中特殊工况阀门的技术咨询，特殊设计和制造。',
      '提供阀门后期的材料升级，热处理及材料表面硬化升级，加工改造等。',
      '提供阀门后期的喷涂或防腐升级。'
    ],
  },
  rights_list1_title: '您将获益',
  rights_list1: [
    '可通过设计改进和更优性能的材料或者特殊材料实现更可靠的性能，更完善的使用，更长的寿命。',
  ],
  rights_list2_title: '为此，我们遵循一套特定的升级流程',
  rights_list2: [
    '我们可以对材料、阀内件等提出升级建议，然后根据这些初始建议创建详细实施方案。并确保所有升级零件都有12个月的保修期。',
    '我们提供持续的专家咨询，可以通过电话、电子邮件或者根据客户要求委派专家到现场咨询。',
    ' 对于现有的KELK阀门，我们可提供快速更换服务，我们也可以为第三方阀门设备的升级和阀内件改装提供建议。'
  ]
}

// 诊断测试
const diagnosticTest = {
  title: '精准护航全生命周期',
  content: `
  无锡凯尔克配备高精度检测矩阵，X射线探伤、超声波缺陷定位、金相显微分析等20余项无损检测，覆盖材料应力-腐蚀-疲<br />
  劳全维度评估。依托 ASTM/EIC 标准冶金电子联合测试平台，同步提供智能传感器寿命预测与流体动力学仿真验证<br />
  为氢能储运、超临界火电等场景定制 ASME B16.34 合规诊断报告，以数据驱动设备安全跃升。
  `,
  grid_menu_title: [
    '状态监测',
    '性能与效率测试',
    '噪声测试',
    '振动和应力分析',
    '工程设计',
    '材料工程与系统分析',
    '先进设备的升级和重估 ',
    '逆向工程和部件加固'
  ],
  rights_list_title: '您将获益',
  rights_list: [
    '阀门运行数据效率透明，确保阀门的持续运行',
    '通过发现优化潜力或损伤原因，提升经济性和可用性',
    '制造商专有技术知识 ‒ 从使用工况、改造材料和阀门结构直至重新设计阀门'
  ]
}

// 技术培训
const technicalTraining = {
  title: '赋能工业人才生态圈',
  content: `
  无锡凯尔克基于60年的实战经验，打造储能、LNG等高端领域阀门全生命周期管理课程体系，助力客户构建专业工程师团队。<br />
  通过ASME BPE认证的沉浸式培训矩阵——涵盖三维拆解仿真、智能诊断沙盘演练及标准案例库，同步提供氢能储运阀门运维、超低温密封失效分析等专项培训，以“理论+工厂实景+数字化诊断”三维赋能模式，让技术传承匹配企业战略升级需求。
  `,
  group1: [
    {
      title: '赋能工业智造人才链',
      content: `我们以“全场景实战赋能”为核心，为企业打造阶梯式培训体系——从阀门基础运维到精密诊断技术，覆盖ASME BPE认证课程、智能定位器联调及超低温失效分析等高阶模块。依托三维流体仿真平台与智能诊断沙盘，结合标准案例库，为初级技工至资深工程师定制专属成长路径，助力企业实现故障率降低45%、维保效率提升60%。同步为LNG储运、氢能工程等终端用户提供周期性认证培训，联合全球顶尖实验室开发VR沉浸式拆装模拟系统，以数字化知识体系筑牢工业安全防线，并为企业建立“技术人才库”与终身学习档案，赋能中国智造核心竞争力迭代升级`,
    },
    {
      title: '重构流体控制技术极',
      content: `我们由 ASME/API 认证专家领衔，旨在打造“总部基地 + 全球联训”的双轨教学模式——在江苏无锡智能制造中心提供沉浸式工厂实景课程，或赴客户指定场所开展定制化专场培训。课程体系主要以“阶梯式知识图谱”为核心：从阀门流体力学原理、模块化拆解等基础赋能，再到超临界工况参数计算、三维逆向工程仿真等高阶攻坚，并同步融入电站主蒸汽阀寿命预测、LNG深冷密封失效分析等实战案例。依托于智能诊断沙盘与VR虚拟装配系统，实现学员技能跃迁，助力企业设备故障率降低50%、维保成本缩减35%，以技术生态闭环赋能中国智造全球竞争力`,
    },
  ],
  group2: {
    title: '精英人才全链路赋能方案',
    txt_list: [
      `我们以“阶梯式赋能模型”为核心，基于服务全球30国超200家能源巨头的实战经验，为企业量身定制阀门全生命周期管理课程——从基础运维到核电级精密诊断，结合ASME BPE国际标准与智能流体仿真技术，精准匹配企业战略需求。`,
      '通过流体动力学仿真平台、三维拆解沙盘及API 6D认证案例库，学员可深度掌握超低温密封失效预判、智能定位器联调等前沿技能，培训后设备故障率平均下降40%，团队响应效率提升60%，助力企业构筑工业4.0时代的技术护城河。'
    ],
  },
  group3: {
    title: '可定制的培训模块',
    subTitle: '您可以根据员工实际的需求来决定接受培训的具体内容，但以下是一些较常规的培训模块供参考，可以单独单项学习，也可以作为完整课程的一部分内容进行学习。',
    list: [
      '控制阀的概念及结构简介。',
      '阀门及执行机构组件。',
      '执行机构及定位器校准和执行机构反作用。',
      '维护、检修及故障排除。',
      '控制阀尺寸计算及选型的基本原理。',
      '控制阀尺寸、选型和噪音计算。',
      '使用计算软件进行控制阀选型及尺寸计算。'
    ]
  }
}



export default {
  title: '客户服务',
  // subTitle: '无锡凯尔克（KELK）——全球高端流体控制全生命周期服务领航者',
  subTitle: '全生命周期服务领航者',
  tab_list,
  main_content_text,
  main_content_list,
  baseMmaintenance,
  onlineMaintenance,
  sparePartsMapping,
  upgradingAndReconstruction,
  diagnosticTest,
  technicalTraining,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/customerServicePage.js